const LOADING = 'Loading…';

export type BloxBlockTitleMode = 'Plan' | 'Builder';

/** Model hub tabs: Dashboard, Blocks, Dimensions, Data */
export function buildBloxModelSectionTitle(section: string, modelName: string | undefined): string {
  const model = modelName?.trim() || LOADING;
  return `${section} – ${model} – Blox`;
}

/** Block plan/builder: Block Name (Mode) – Model Name – Blox */
export function buildBloxBlockTitle(
  blockName: string | undefined,
  modelName: string | undefined,
  mode: BloxBlockTitleMode,
): string {
  const block = blockName?.trim() || LOADING;
  const model = modelName?.trim() || LOADING;
  return `${block} (${mode}) – ${model} – Blox`;
}
